import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b854c34e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-sku-box" }
const _hoisted_2 = { class: "goods-sku-head-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods-sku-title-box" }, "规格名", -1))
const _hoisted_4 = { class: "goods-sku-title-right-box" }
const _hoisted_5 = { class: "goods-sku-content-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sku-spec-title" }, "规格值", -1))
const _hoisted_7 = { class: "sku-spec-content" }
const _hoisted_8 = { class: "sku-spec-input-inner-box" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.modelValue.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.name) = $event))
        }, null, 8, ["modelValue"]),
        (_ctx.cover)
          ? (_openBlock(), _createBlock(_component_el_checkbox, {
              key: 0,
              modelValue: _ctx.modelValue.showImage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.showImage) = $event)),
              "true-label": "1",
              "false-label": "0"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加规格图片")
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "remove-item remove-item-parent",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('destory')), ["stop"]))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Close)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_draggable, {
          modelValue: _ctx.modelValue.specList,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.specList) = $event)),
          style: {"display":"flex","flex-wrap":"wrap"}
        }, {
          item: _withCtx(({ element, index }) => [
            (_openBlock(), _createElementBlock("div", {
              class: "sku-spec-input-box",
              key: index
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_input, {
                  modelValue: element.name,
                  "onUpdate:modelValue": ($event: any) => ((element.name) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", {
                  class: "remove-item",
                  onClick: _withModifiers(($event: any) => (_ctx.modelValue.specList.splice(index, 1)), ["stop"])
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Close)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_9)
              ]),
              (_ctx.modelValue.showImage == 1)
                ? (_openBlock(), _createBlock(_component_ui_upload_image_list, {
                    key: 0,
                    modelValue: element.image,
                    "onUpdate:modelValue": ($event: any) => ((element.image) = $event),
                    showClose: false
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_link, {
            type: "primary",
            onClick: _ctx.addSku,
            underline: false
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加规格值")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}